<template>
  <success :show-promotes='showPromotes && !isSetupZP'>
    <thanks :email='email' :title='title'>
      <view-account v-if='hasOneTimeWebinar' />
      <template v-else-if='isNeedAssignsUser'>
        <span slot='subtitle' v-html="$t('billing.success.downgrade_txt')" />
        <subtitle :sub-title='assignText' />
        <div>
          <user-management-cta :cta-name="$t('billing.success.unassign_users')" />
          <view-account type='plain' />
        </div>
      </template>
      <template v-else-if='isDowngrade || isDownsell'>
        <span slot='subtitle' v-html="$t('billing.success.downgrade_txt')" />
        <view-account />
      </template>
      <template v-else-if='isShowSetupCta || isSetupZP'>
        <span slot='subtitle' v-if='isDownsell' v-html="$t('billing.success.downgrade_txt')" />
        <subtitle :sub-title="isSetupZP ? setUpZpDesc : $t('billing.success.confirmation.set_up_desc')" />
        <subtitle v-if='bookWithSpecialistLink && isSetupZP' :sub-title="$t('billing.pbx.pbx_specialist_new')" />
        <set-up-action :eligibleProductTypeJson='eligibleProductTypeJson' />
        <book-with-a-specialist v-if='isSetupZP' />
      </template>
      <!-- upsell -->
      <template v-else-if='isUpsell'>
        <subtitle :sub-title="$t('billing.success.confirmation.user_assign_desc')" />
        <user-management-cta :cta-name="$t('billing.success.confirmation.user_cta')" />
      </template>
      <template v-else>
        <view-account />
      </template>
      <download-action v-if='isShowDownload' />
    </thanks>
  </success>
</template>

<script>
import Success from '@/plans/ZOOM_MEETING/success.vue';
import { safeJSONParse } from '@/utils';
import { mapGetters } from 'vuex';
import { planTypes } from '@/common/constants';
import BookWithASpecialist from '@/views/succezz/thanks-template/book-with-a-specialist.vue';

export default {
  name: 'BusinessPlus',
  components: { BookWithASpecialist },
  extends: Success,
  data() {
    return {
      planType: planTypes.ZONE_PRO_PLUS,
    };
  },
  computed: {
    ...mapGetters(['migratePlanState']),
    isAllowSetup() {
      return true;
    },
    bookWithSpecialistLink() {
      return this.successConfig.bookWithSpecialistLink;
    },
    isSetupZP() {
      if (this.$context.is.buyNow || this.$context.is.basic2pro) return !safeJSONParse(this.eligibleProductTypeJson).length;
      return false;
    },
    setUpZpDesc() {
      return this.$t('billing.success.confirmation.set_up_zp_desc');
    },
    isDowngrade() {
      return this.migratePlanState.is.downgrade;
    },
    isDownsell() {
      if (!this.$context.is.edit) return false;
      if (this.isNeedAssignsUser) return true;
      return this.boughtPlans.filter(p => {
        return p.type === this.planType;
      }).find(p => {
        const { has_downgrade_request, has_decrease_request, has_same_pending_plan } = p.cartInfo;
        return (has_downgrade_request || has_decrease_request || has_same_pending_plan);
      });
    },
  },
};
</script>
